<div class="role-section">
    <p-tabs value="0">
        <p-tablist>
            <p-tab value="0">Role Base</p-tab>
            <p-tab value="1">CWE Rate</p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="0">
                <role-base></role-base>
            </p-tabpanel>
            <p-tabpanel value="1">
                <cwe-rate></cwe-rate>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>